import { parseQueryStringToObj } from './parseQueryStringToObj';
import { appendQueryToUrl } from './appendQueryToUrl';
import { parseUrlToObject } from './parseUrlToObject';
/**
 * same as appendQueryToUrl
 * but will replace original query that has the same name
 * @param url (a full url)
 * @param query
 * @param withOrigin
 */
export function mergeQueryToUrl(
  url: string,
  query: Record<string, string | number | boolean | null | undefined>,
  withOrigin = true,
): string {
  const { origin, pathname, search } = parseUrlToObject(url);
  const originalQuery = parseQueryStringToObj(search);
  const newQuery = {
    ...originalQuery,
    ...query,
  };
  const urlWithoutQuery = withOrigin ? origin + pathname : pathname;
  return appendQueryToUrl(urlWithoutQuery, newQuery);
}
